export default () => ({
  customCell: {
    wordBreak: 'break-all',
  },
});
